import { NgModule } from '@angular/core';

import { FeaturesModule } from '../features/features.module';
import { SharedDependenciesModule } from '../shared';

import { BookingCheckoutComponent } from './booking-checkout/booking-checkout.component';
import { BookingContingentSubscriptionDetailsComponent } from './booking-contingent-subscription-list/booking-contingent-subscription-details/booking-contingent-subscription-details.component';
import { BookingContingentSubscriptionListComponent } from './booking-contingent-subscription-list/booking-contingent-subscription-list.component';
import { BookingContingentSubscriptionsCheckoutComponent } from './booking-contingent-subscriptions-checkout/booking-contingent-subscriptions-checkout.component';
import { BookingContingentSubscriptionsSummaryComponent } from './booking-contingent-subscriptions-summary/booking-contingent-subscriptions-summary.component';
import { BookingContingentSubscriptionsComponent } from './booking-contingent-subscriptions/booking-contingent-subscriptions.component';
import { BookingDevicesListComponent } from './booking-devices-list/booking-devices-list.component';
import { BookingDevicesComponent } from './booking-devices/booking-devices.component';
import { BookingOverviewFlatRateComponent } from './booking-overview-flat-rate/booking-overview-flat-rate.component';
import { FlatRateStatusTilesComponent } from './booking-overview-flat-rate/flat-rate-status-tile/flat-rate-status-tiles.component';
import { BookingOverviewSubscriptionPerInstallationComponent } from './booking-overview-subscription-per-installation/booking-overview-subscription-per-installation.component';
import { BookingOverviewComponent } from './booking-overview/booking-overview.component';
import { BookingPlansSpecComponent } from './booking-plans/booking-plans-spec/booking-plans-spec.component';
import { BookingPlansComponent } from './booking-plans/booking-plans.component';
import { BookingSubscriptionDetailsComponent } from './booking-subscription-details/booking-subscription-details.component';
import { BookingSubscriptionListComponent } from './booking-subscription-list/booking-subscription-list.component';
import { NoSearchResultComponent } from './booking-subscription-list/no-search-results/no-search-results.component';
import { BookingSummaryComponent } from './booking-summary/booking-summary.component';
import { BookingWrapperComponent } from './booking-wrapper/booking-wrapper.component';
import { BookingRouting } from './booking.routing';
import { BookingComponent } from './booking/booking.component';
import { FlatBookingCheckoutComponent } from './flat-booking-checkout/flat-booking-checkout.component';
import { FlatBookingSummaryComponent } from './flat-booking-checkout/flat-booking-summary/flat-booking-summary.component';
import { FlatBookingPlansSpecComponent } from './flat-booking-plans/flat-booking-plans-spec/flat-booking-plans-spec.component';
import { FlatBookingPlansComponent } from './flat-booking-plans/flat-booking-plans.component';
import { FlatBookingComponent } from './flat-booking/flat-booking.component';
import { FlatSubscriptionSummaryComponent } from './flat-subscription-summary/flat-subscription-summary.component';
import { SubscriptionSummaryWrapperComponent } from './subscription-summary-wrapper/subscription-summary-wrapper.component';
import { SubscriptionSummaryComponent } from './subscription-summary/subscription-summary.component';
import { BookableInstallationComponent } from './booking-devices/bookable-installation/bookable-installation.component';
import { BookingExtendTrialListComponent } from './booking-extend-trial/booking-extend-trial-list/booking-extend-trial-list.component';
import { BookingExtendTrialDetailsComponent } from './booking-extend-trial/booking-extend-trial-details/booking-extend-trial-details.component';
import { BookingUnregisteredListComponent } from './booking-unregistered-list/booking-unregistered-list.component';
import { CommercialBookingComponent } from './commercial-booking/commercial-booking.component';
import { CommercialBookingPlansComponent } from './commercial-booking-plans/commercial-booking-plans.component';
import { CommercialBookingPlansSpecComponent } from './commercial-booking-plans/commercial-booking-plans-spec/commercial-booking-plans-spec.component';
import { CommercialBookingCheckoutComponent } from './commercial-booking-checkout/commercial-booking-checkout.component';
import { CommercialBookingSummaryComponent } from './commercial-booking-checkout/commercial-booking-summary/commercial-booking-summary.component';
import { BookingOverviewCommercialComponent } from './booking-overview-commercial/booking-overview-commercial.component';
import { CommercialStatusTileComponent } from './booking-overview-commercial/commercial-status-tile/commercial-status-tile.component';
import { CommercialSubscriptionSummaryComponent } from './commercial-subscription-summary/commercial-subscription-summary.component';
import { BookingPlansVoucherComponent } from './booking-voucher-na/booking-plans-voucher/booking-plans-voucher.component';
import { BookingVoucherDevicesComponent } from './booking-voucher-na/booking-voucher-devices/booking-voucher-devices.component';
import { BookingVoucherCheckoutComponent } from './booking-voucher-na/booking-voucher-checkout/booking-voucher-checkout.component';
import { BookingPlansPackageContentComponent } from './booking-plans/booking-plans-package-content/booking-plans-package-content.component';
import { VoucherSubscriptionSummaryComponent } from './booking-voucher-na/voucher-subscription-summary/voucher-subscription-summary.component';
import { BookingOverviewVoucherComponent } from './booking-voucher-na/booking-overview-voucher/booking-overview-voucher.component';
import { VoucherBookingTileComponent } from './booking-voucher-na/booking-overview-voucher/voucher-booking-tile/voucher-booking-tile.component';
import { BookingVoucherComponent } from './booking-voucher-na/booking-voucher/booking-voucher.component';
import { ViDswFooterComponent } from '../shared/+design-system-web/vi-dsw-footer/vi-dsw-footer.component';
import { AdditionalServicesComponent } from './booking-plans/additional-services/additional-services.component';

@NgModule({
  declarations: [
    BookingComponent,
    BookingDevicesComponent,
    BookingPlansComponent,
    BookingSummaryComponent,
    BookingDevicesListComponent,
    BookingCheckoutComponent,
    SubscriptionSummaryComponent,
    BookingPlansSpecComponent,
    BookingOverviewComponent,
    BookingSubscriptionDetailsComponent,
    BookingSubscriptionListComponent,
    NoSearchResultComponent,
    BookingWrapperComponent,
    SubscriptionSummaryWrapperComponent,
    FlatBookingComponent,
    FlatBookingPlansComponent,
    FlatBookingPlansSpecComponent,
    FlatBookingCheckoutComponent,
    FlatBookingSummaryComponent,
    FlatSubscriptionSummaryComponent,
    BookingOverviewSubscriptionPerInstallationComponent,
    BookingOverviewFlatRateComponent,
    FlatRateStatusTilesComponent,
    BookingContingentSubscriptionListComponent,
    BookingContingentSubscriptionDetailsComponent,
    BookingContingentSubscriptionsComponent,
    BookingWrapperComponent,
    BookingContingentSubscriptionsSummaryComponent,
    BookingContingentSubscriptionsCheckoutComponent,
    BookingExtendTrialListComponent,
    BookingExtendTrialDetailsComponent,
    BookableInstallationComponent,
    BookingUnregisteredListComponent,
    CommercialBookingComponent,
    CommercialBookingPlansComponent,
    CommercialBookingPlansSpecComponent,
    CommercialBookingCheckoutComponent,
    CommercialBookingSummaryComponent,
    BookingOverviewCommercialComponent,
    CommercialStatusTileComponent,
    CommercialSubscriptionSummaryComponent,
    BookingVoucherComponent,
    BookingPlansVoucherComponent,
    BookingVoucherDevicesComponent,
    BookingVoucherCheckoutComponent,
    BookingPlansPackageContentComponent,
    VoucherSubscriptionSummaryComponent,
    BookingOverviewVoucherComponent,
    VoucherBookingTileComponent,
  ],
  imports: [
    SharedDependenciesModule,
    BookingRouting,
    FeaturesModule,
    ViDswFooterComponent,
    AdditionalServicesComponent,
  ],
})
export class BookingModule {}
